import { createFeatureSelector, createSelector } from '@ngrx/store';

import { ChatChannelListState } from './chat-channel-list.types';

export const selectChatChannelListState =
  createFeatureSelector<ChatChannelListState>('chatChannelList');

export const selectChatSettings = createSelector(
  selectChatChannelListState,
  (state) => state.chatSettings,
);
